export default __webpack_public_path__ + "static/media/up-arrow.f9e0aa04.svg";